export const fetchAirportData = async () => {
  try {
    // Call api here
    //const response = await fetch("https://your api url");
    const data = await getMockedData();
    return data;
  } catch (e) {
    console.log(e);
  }
};

const getMockedData = () => {
  return [
    {"key": 1, "name": "ALB-ALBANY"},
    {"key": 2, "name": "ABQ-ALBUQUERQUE"},
    {"key": 3, "name": "ATLANTA - ATL"},
    {"key": 4, "name": "AUSTIN - AUS"},
    {"key": 5, "name": "BALTIMORE - BWI"},
    {"key": 6, "name": "BIRMINGHAM - BMI"}
  ];
};


// WEBPACK FOOTER //
// ./src/api/airportDataApi.js